/**
 * Display names for the AI skills (keys as defined by the backend, see
 * AI_AGENT_SYSTEM_SPEC.md §2).
 */
export const AI_SKILL_LABELS = {
  report_review: "Tekst controleren",
  mention_link: "Vermeldingen voorstellen",
  follow_up_suggest: "Taken voorstellen",
  trait_suggest: "Kenmerken voorstellen",
  account_briefing: "Samenvatting van een persoon",
};

export function skillLabel(key) {
  return AI_SKILL_LABELS[key] || key;
}

/**
 * The skills that check a report draft, in the order they are shown, with the
 * short section title and icon used in the AI-check sheet.
 */
export const DRAFT_CHECK_SECTIONS = [
  { key: "report_review", title: "Tekst", icon: "mdi-text-box-check-outline" },
  { key: "mention_link", title: "Vermeldingen", icon: "mdi-at" },
  {
    key: "follow_up_suggest",
    title: "Taken",
    icon: "mdi-calendar-check-outline",
  },
  { key: "trait_suggest", title: "Kenmerken", icon: "mdi-tag-multiple" },
];
